module.exports = __webpack_public_path__ + "static/media/shopping_bag-24px.c1e065e5.svg";